import Radio from '@mui/material/Radio';
import { styled } from '@mui/system';
import colors from '../../assets/colors';

const StyledRadio = styled(Radio)({
  '&.MuiRadio-root': {
    color: colors.oldAgroweGreen,
    '&.Mui-checked': {
      color: colors.oldAgroweGreen,
    },
  },
});

const GreenRadio = (props) => <StyledRadio color="default" {...props} />;
export default GreenRadio;
